<app-page-hero
  badge="تواصل معنا"
  title="نحن هنا لخدمتك"
  descriptionLine1="سواء كان لديك سؤال عن منصتنا، أو تريد الاستفسار عن فرصة تعاقدية معينة، أو تحتاج إلى مساعدة فنية، أو تفكر في الانضمام إلى برنامج "
  descriptionLine2="الوسطاء — فريقنا جاهز للرد عليك."
  bgImage="/images/bg.png"
>
</app-page-hero>
